<template>
  <div :class="{'form-group': true,  'form-group--inline': inline}">
    <slot></slot>
  </div>
</template>
<script setup lang="ts">
withDefaults(defineProps<{
  inline?: boolean
}>(), {
  inline: false
})
</script>
<style lang="scss">
.form-group {
  @media only screen and (min-width: 720px) {
    display: flex;
    align-items: center;
  }
  margin-bottom: 10px;
  position: relative;
  &.form-group--inline {
    margin-bottom: 20px;
    > div {
      flex: 1;
      padding-right: 10px;
      margin-bottom: 10px;
      @media only screen and (min-width: 720px) {
        margin-bottom: 0;
      }
    }
    label {
      margin-bottom: 5px;
    }
  }
}
</style>